import { createBrowserHistory, History } from 'history';

const history: History = createBrowserHistory();

export const navTo = (location: string = '/', state?: any): void => {
  history.push(location, state);
};

export default history;
